// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 796 ? "5330eab6" : chunkId) + "." + {"487":"7e69d30572ac3b62","691":"bfbbb1e330858647","796":"bd498829da5bf771"}[chunkId] + ".js";
};